import { isAxiosError } from 'axios';
import { Axios } from '@cbridge-utils/axios-observable';
import type { AuthService } from '@cbridge-packages/auth';
import { RefreshTokenEngine } from './RefreshTokenEngine';

export function setupErrorInterceptor(api: Axios, auth: AuthService) {
  const refreshTokenEngine = new RefreshTokenEngine(api, auth);

  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (isAxiosError(error)) {
        const handled = await refreshTokenEngine.handleUnauthorized(error);
        if (handled) {
          return handled;
        } else {
          return Promise.reject(error);
        }
      }

      return Promise.reject(new Error(error));
    },
  );
}
